import React, { Component } from 'react';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import KelasDropdown from '../masterDropDown/DropdownKelas';
import DropdownGuru from '../masterDropDown/DropdownGuru';
import KelasSearch from '../../../../entity/KelasSearch';

export default class ModalAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            showModal: false,
            KelasPararel: [],
            sekolah: {},
            kelas: [],
            idKelas: '',
            namaKelasParalel: '',
            guru: [],
            idGuru: ''
        }
        
        this.onInputAddChange = this.onInputAddChange.bind(this);
    }

    onInputAddChange(event) {
        const fieldName = event.target.name;
        const fieldValue = event.target.value;
        this.setState({
            [fieldName]: fieldValue
        })
        this.props.onChange(fieldName, fieldValue);
    }

    clearStateModalAdd() {
        this.setState({
            idKelas: '',
            namaKelasParalel: '',
            idGuru: ''
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.statusModal === false) {
            this.clearStateModalAdd();
        }
    }
    
    render() {        
        return(
            <div>
                <button className="btn btn-primary btn-sm" data-toggle="modal" data-target="#addKelas" data-backdrop="static" data-keyboard="false" title="tambah" onClick={() => { this.props.onChange('isShowAdd', true); this.props.clearAlert()}}>
                    <i className="fa fa-plus">&nbsp; Kelas</i>
                </button>

                {this.props.statusModal &&
                <div className="modal fade show" id="addKelas" style={{display: 'block', paddingRight: '17px', backgroundColor: 'rgba(0,0,0,0.8)'}} aria-modal="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content"> 
                            <div className="modal-header">
                                <h4 className="modal-title">Tambah Kelas</h4>
                                <button type="button" className="close" data-dismiss="modal" onClick={() => this.props.onChange('isShowAdd', false)}>&times;</button>
                            </div>
                            
                            <form id="form-tambah" onSubmit={this.props.eventSubmit}>
                                <div className="modal-body">
                                        <div className="form-group">
                                            <label for="recipient-name" className="col-form-label">Kelas</label>
                                            <select className="form-control" name="idKelas" id="idKelas" value={this.state.idKelas} onChange={this.onInputAddChange.bind(this)} required>
                                                <option value="" selected>-- Pilih Kelas --</option>
                                                <KelasDropdown kelas={this.props.kelasDropdown}/>
                                            </select>
                                        </div>
                                        
                                        <div className="form-group">
                                            <label for="recipient-name" className="col-form-label">Nama kelas Pararel</label>
                                            <input type="text" className="form-control" name="namaKelasParalel" id="namaKelasParalel" value={this.state.namaKelasParalel} placeholder="Nama Kelas Pararel" autoComplete="off" onChange={this.onInputAddChange.bind(this)} required/>
                                        </div>

                                        <div className="form-group">
                                            <label for="label-wali-kelas" className="col-form-label">Wali Kelas</label>
                                            <select className="form-control" name="idGuru" id="idGuru" value={this.state.idGuru} onChange={this.onInputAddChange.bind(this)} required>
                                                <option value="" selected>-- Pilih Wali Kelas --</option>
                                                <DropdownGuru guru={this.props.guruDropdown}/>
                                            </select>
                                        </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => this.props.onChange('isShowAdd', false)}>Batal</button>
                                    <button type="submit" className="btn btn-primary">Simpan</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                }
            </div>
        );
    }
}
